var render, staticRenderFns
import script from "./UIFormateDate.vue?vue&type=script&lang=js&"
export * from "./UIFormateDate.vue?vue&type=script&lang=js&"
import style0 from "./UIFormateDate.vue?vue&type=style&index=0&id=5e14fc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e14fc2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e14fc2c')) {
      api.createRecord('5e14fc2c', component.options)
    } else {
      api.reload('5e14fc2c', component.options)
    }
    
  }
}
component.options.__file = "src/components/ui/render/UIFormateDate.vue"
export default component.exports